export enum StatusCode {
  MovedPermanently = 301,
  NotFound = 404,
  UnprocessableEntity = 422,
  TooManyRequests = 429,
  InternalServerError = 500,
}
